// extracted by mini-css-extract-plugin
export default {"list":"card-list_list__9q1ZX"};